/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { getBaseCode } from '../../../helpers/tracking/product/dataLayerProductHelpers';

// maps a personalized-content product (from useExperience's experience.products)
// into the recipient.products[i] shape that the gift list consumes.
export const mapExperienceProductToRecipientProduct = (experienceProduct) => {
    const retailPrice = experienceProduct?.skuPriceRange?.retail?.[0]?.value;
    const salePrice = experienceProduct?.skuPriceRange?.sale?.[0]?.value;
    const discountPrice = salePrice && retailPrice && salePrice < retailPrice ? salePrice : '';
    const crossedPrice = discountPrice ? retailPrice : '';
    const imageName = experienceProduct?.image?.name;
    const imagePath = experienceProduct?.image?.path;
    const image = imagePath && imageName ? `${imagePath}${imageName}x.jpg` : '';
    const baseCode = getBaseCode(experienceProduct?.partNumber, true);

    return {
        id: baseCode,
        content: '',
        crossedPrice,
        discountPrice,
        image,
        name: experienceProduct?.name,
        price: retailPrice,
        sku: baseCode,
        customAttributes: {},
        priceRules: [],
        partNumber: baseCode,
        productPartNumber: experienceProduct?.partNumber,
        status: '',
        seoproductDisplayURL: experienceProduct?.seo?.url,
        oGPartNumber: experienceProduct?.partNumber,
        productType: experienceProduct?.productType,
        hasItemSendPrevious: false,
    };
};

export const mapExperienceProductToTrackingProduct = (experienceProduct) => ({
    partNumber: experienceProduct?.partNumber,
    name: experienceProduct?.name,
});

export const getUniqueTrackingProducts = (trackingResultsByRecipient = {}, recipientIds = []) => (
    recipientIds.reduce((uniqueProducts, recipientId) => {
        const trackingProducts = trackingResultsByRecipient[recipientId]?.products || [];
        trackingProducts.forEach((product) => {
            const alreadyIncluded = uniqueProducts.find((item) => item.partNumber === product.partNumber);
            if (!alreadyIncluded) uniqueProducts.push(product);
        });
        return uniqueProducts;
    }, [])
);
